module.exports = __webpack_public_path__ + "static/banner-update-data-co-6f3df9c8fe9d46c49c70441a1ccfc69f.jpg";